// extracted by mini-css-extract-plugin
export var shortSplit = "shortSplit-module--short-split--18ece";
export var shortSplitContent = "shortSplit-module--short-split-content--93766";
export var shortSplitCta = "shortSplit-module--short-split-cta--e2958";
export var shortSplitCtaLink = "shortSplit-module--short-split-cta-link--2cf7a";
export var shortSplitCtaText = "shortSplit-module--short-split-cta-text--152b8";
export var shortSplitImage = "shortSplit-module--short-split-image--fba24";
export var shortSplitWrap = "shortSplit-module--short-split-wrap--05fda";